import CreatedBy from './CreatedBy';

export default CreatedBy;
